import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, DirectionsRenderer, DirectionsService, GoogleMap, InfoWindowF, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { Button, Card, Col, Descriptions, Input, Modal, Row, Space, Table, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
const { Title } = Typography;

// ขนาดของ Map
const containerStyle = {
    width: "100%",
    height: "500px",
};
// พิกัดเริ่มต้น (ตัวอย่าง: ขอนแก่น)
const defaultCenter = { lat: 16.460080198821046, lng: 102.83231745521805 };

const columns = [
    {
        title: "ลำดับ",
        key: "index",
        render: (_, __, index) => index + 1, // ใช้ index + 1
    },
    {
        title: "เลขโฉนด",
        dataIndex: "numberLand",
        key: "numberLand",
    },
    {
        title: "ระวาง",
        dataIndex: "numberLandlawang",
        key: "numberLandlawang",
    },
    {
        title: "อำเภอ",
        dataIndex: "district",
        key: "district",
    },
    {
        title: "ตำบล",
        dataIndex: "subdistrict",
        key: "subdistrict",
    },
    {
        title: "รหัสไปรษณีย์",
        dataIndex: "zipcode",
        key: "zipcode",
    },
];

function MapRoutes({ open, close, onSave, isLoaded, dataSendForMapRoute }) {
    const mapRef = useRef(null);
    const [directions, setDirections] = useState(null);

    // ✅ คำนวณเส้นทางครั้งเดียวตอน dataSendForMapRoute เปลี่ยน
    useEffect(() => {
        if (!isLoaded || !dataSendForMapRoute || dataSendForMapRoute.length < 2) return;

        // แปลง lat/lng ทุกตัวให้เป็น float
        // กรองเฉพาะ loc ที่มี lat/lng ถูกต้อง
        const parsedLocations = dataSendForMapRoute
            .map((loc) => {
                const lat = parseFloat(loc.lat);
                const lng = parseFloat(loc.lng);
                if (isNaN(lat) || isNaN(lng)) return null; // ❌ ข้ามจุดที่ไม่ valid
                return { lat, lng };
            })
            .filter((loc) => loc !== null); // ✅ เก็บเฉพาะที่ถูกต้อง

        if (parsedLocations.length < 2) {
            console.warn("ไม่พบพิกัดเพียงพอในการคำนวณเส้นทาง");
            setDirections(null);
            return;
        }

        const origin = parsedLocations[0]; // ตำแหน่งที่ เริ่มต้น
        const destination = parsedLocations[parsedLocations.length - 1];
        const waypoints = parsedLocations.slice(1, -1).map((loc) => ({
            location: loc,
            stopover: true,
        }));

        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin,
                destination,
                waypoints,
                travelMode: "DRIVING",
                optimizeWaypoints: true,
            },
            (result, status) => {
                if (status === "OK" && result) {
                    setDirections(result);
                } else {
                    setDirections(null);
                    console.error("Directions request failed due to ", status);
                }
            }
        );
    }, [isLoaded, dataSendForMapRoute]);

    const handleClose = () => close(false);
    if (!isLoaded) return <div>Loading...</div>;
    return (
        <Card
            style={{
                margin: "20px auto",
                borderRadius: 10,
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
        >
            <Modal open={open} onCancel={handleClose} width={900} footer={null}>

                <Title
                    level={3}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#2c3e50",
                        gap: "10px",
                    }}
                >
                    <EnvironmentOutlined style={{ color: "#1890ff" }} />
                    เส้นทางการเดินทาง
                </Title>
                <Row justify={'center'}>
                    <Col span={24}>
                        <Table
                            columns={columns}
                            dataSource={dataSendForMapRoute}
                            rowKey="landId"
                            bordered
                            pagination={false}
                        />
                    </Col>
                </Row>
                <Row
                    style={{
                        borderRadius: 20,
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        margin: "20px 0",
                    }}
                >

                    {/* )} */}
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={
                            dataSendForMapRoute && dataSendForMapRoute.length > 0
                                ? {
                                    lat: parseFloat(dataSendForMapRoute[0].lat),
                                    lng: parseFloat(dataSendForMapRoute[0].lng),
                                }
                                : defaultCenter
                        }
                        zoom={13}
                        onLoad={(map) => (mapRef.current = map)}
                    >
                        {directions && (
                            <DirectionsRenderer
                                directions={directions}
                                options={{
                                    polylineOptions: {
                                        strokeColor: "#00AA00", // 🟢 เส้นสีเขียว
                                        strokeOpacity: 0.8,
                                        strokeWeight: 6,
                                    },
                                    suppressMarkers: false, // true = ไม่แสดง marker ของ Google
                                }}
                            />
                        )}
                    </GoogleMap>
                </Row>

                <Row justify={"center"} style={{ margin: 8 }}>
                    <Space>
                        <Button key="close" onClick={handleClose}>
                            ปิด
                        </Button>
                    </Space>
                </Row>
            </Modal>
        </Card>
    )
}

export default MapRoutes